import moment from "moment";

(function (w) {

      const requiredElementSelector = '#calculator-vacation';
      const requiredElement = document.querySelector(requiredElementSelector);

      if (!requiredElement) {
        return;
      }
        w._minZP = null;
        w._holidaysArray = [];
      let minZP;
      let holidaysArray = [];
      const date = document.querySelector('input[name="date_vacation_start"]');
      const dateStartWork = document.querySelector('input[name="date_work_start"]');

      if (date) {
          refreshSalary(date.value);
      }
      if (dateStartWork) {
          refreshHolidays(dateStartWork.value);
      }

      function refreshSalary(date) {
        fetch(`/nsl-calculator/get-min-salary?date_from=${date}&date_to=${date}`)
            .then((response) => response.json())
            .then((res) => {
              minZP = res[0].min_salary;
              w._minZP = minZP;
              w.uteka.CalculatorVacation = createCalculatorVacation();
              w.calculatorVacation.setFieldData('number', 'min_salary', w._minZP);
            })
            .catch(() => {});
      }

      function refreshHolidays(date) {
        const dateStartVacation = document.querySelector('input[name="date_vacation_start"]');
        const inputDate = new Date(date.split('.').reverse().join('-'));
        const year = inputDate.getFullYear();

        const startOfYear = `01.01.${year}`;
        const endOfYear = `31.12.${year}`;

        fetch(`/nsl-calculator/get-holidays?date_from=${startOfYear}&date_to=${dateStartVacation.value}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(response => response.json())
            .then(res => {
              holidaysArray = Array.isArray(res) ? res : [];
              window._holidaysArray = holidaysArray;
              window.uteka.CalculatorVacation = createCalculatorVacation();
              window.calculatorVacation.setFieldData('array', 'holidays', window._holidaysArray);
            })
            .catch(error => {
              console.error('Error:', error);
            });
      }

      const mainContainer = document.querySelector("#calculator-vacation");
      if (mainContainer) {
        mainContainer.addEventListener("keyup", (event) => {
          const target = event.target;
          if (
              target.matches("input[name='total_income'], input[name='rate']")
          ) {
            const inputVal = target.value;
            const matchResult = inputVal.match(/(\d+([.,]{1})?([0-9]{1,2})?)/g);
            if (matchResult) {
              target.value = matchResult[0];
            } else {
              target.value = '';
            }
          }
        });
      }

      function isLeap(year) {
        return new Date(year, 1, 29).getDate() === 29;
      }

      function priceFormat(text) {
        text = text.toFixed(2).replace(/./g, function (c, i, a) {
          return i && c !== "." && ((a.length - i) % 3 === 0) ? ' ' + c : c;
        });
        return text;
      }

        function createCalculatorVacation() {
          function CalculatorVacation(options) {
            window.uteka.Base.call(this, options);
            this.state = Object.assign({}, this.state || {}, {
              data: {
                is_leap_year: null,
                vacation_days: null,
                not_working_days: null,
                not_working_days_war: null,
                date_vacation_start: null,
                date_work_start: null,
                rate: null,
                period: null,
                days_for_mid_rate: null,
                middle_rate: null,
                vacation_sum: null,
                total_income: 0,
                min_salary: w._minZP,
                _dif_days: 0,
                _date_vacation_start_mont: null,
                holidays: w._holidaysArray,
              }
            });
            console.log(this);

            if (this.elements.mainEl && this.elements.mainEl instanceof HTMLElement) {
              this.createEvents()
                  .collectData()
                  .preCalculate();
            }
          }
          CalculatorVacation.prototype = Object.create(w.uteka.Base.prototype);

          CalculatorVacation.prototype.constructor = CalculatorVacation;

          CalculatorVacation.prototype.defaultOptions = {
            debug: false,
            elements: {
              main: '#calculator-vacation',
              fields: 'input[type="text"], input[type="number"], .js--select_period, input[type="checkbox"]',
              calculate: '.js-submit',
              periodField: '.js--select_period',
              dynamic: '[data-dynamic]'

            },
            events: {
              init: function () {
              }
            },
            isWorkSaturday: false,

            regexp: {
              date: /^\d{2}\/\d{2}\/\d{4}$/,
              date2: /^\d{2}\.\d{2}\.\d{4}$/
            }
          };

          CalculatorVacation.prototype.convertDate = function (dateStr) {
            if (this.options.regexp.date2.test(dateStr)) {
              dateStr = dateStr.split('.');
              dateStr = dateStr[1] + '/' + dateStr[0] + '/' + dateStr[2]
            }
            return dateStr;
          };

          CalculatorVacation.prototype.setFieldData = function (type, name, val, updateInDome) {
            const selectElement = this.elements.periodFieldEl;
            const choicesInstance = window.choicesSelects.find(instance => instance.passedElement.element === selectElement);
            switch (type) {
              case 'text':
                if (val === parseInt(val) + '') {
                  val = parseInt(val);
                }
                break;
              case 'date':
                val = moment.isMoment(val) ? val : moment(this.convertDate(val));
                break;
              case 'number':
                val = parseFloat(val || 0);
                break;
              case 'hidden':
                val = parseFloat(val || 0);
                break;
              case 'boolean':
                val = !!val;
                break;
              case 'choices':
                choicesInstance.setChoiceByValue(val);
                const changeEvent = new Event('change', { bubbles: true });
                this.elements.periodFieldEl.dispatchEvent(changeEvent);
                break;
              default:
                break;
            }
            if (name === 'rate' || name === 'total_income') {
              const floatVal = val.toString().replace(',', '.');
              val = parseFloat(floatVal);
            }
            this.state.data[name] = val;
            this.setDependencies(name, val);

            if (updateInDome) {
              this.elements.dynamicEl.forEach((el) => {
                let setVal = val;
                const dynamic = el.dataset.dynamic;
                if (dynamic === name) {
                  if (el.classList.contains('price')) {
                    setVal = priceFormat(setVal);
                  }
                  el.innerText = setVal;
                }
              });

              this.elements.fieldsEl.forEach((el) => {
                let setVal = val;
                const dynamic = el.getAttribute('name');
                var fieldType = el.getAttribute('type');
                    var fieldValue = el.value;
                    if (dynamic === name) {
                      if (el.classList.contains('price')) {
                        setVal = priceFormat(setVal);
                      }
                      switch (fieldType) {
                        case 'checkbox':
                          if (fieldValue === setVal) {
                            el.checked = true;
                            el.dispatchEvent(new Event('change'));
                          }
                          break;
                        default:
                          if (dynamic === name) {
                            el.value = setVal;
                          }
                          break;
                      }
                    }
                  });
            }
            return this;
          };
          CalculatorVacation.prototype.getFieldData = function (name) {
            return this.state.data[name] || false;
          };
          CalculatorVacation.prototype.setDependencies = function (name, val) {
            const self = this;
            const setSpecialTotalIncome = function () {
              self.setFieldData(
                      'number',
                      'total_income',
                      self.getFieldData('rate') * 12,
                      true)
                  .setDisabledField('total_income');
            };
            const unsetSpecialTotalIncome = function () {
              self.setEnabledField('total_income');
            };

            switch (name) {
              case 'period':
                switch (val) {
                  case '2':
                    setSpecialTotalIncome();
                    break;
                  default:
                    if (this.getFieldData('no_income')) {
                      unsetSpecialTotalIncome();
                    }
                    break;
                }
                break;
              case 'no_income':
                if (val) {
                  setSpecialTotalIncome();
                } else {
                  if (this.getFieldData('period') !== '2') {
                    unsetSpecialTotalIncome();
                  }
                }
                break;
              case 'date_vacation_start':
                this.setFieldData(
                    'boolean',
                    'is_leap_year',
                    val.isLeapYear()
                );
                this.setFieldData(
                    'date',
                    '_date_vacation_start_mont',
                    moment.isMoment(val) ? val.startOf('month') : ''
                );

                break;
              default:
                break;
            }
            return this;
          };
          CalculatorVacation.prototype.setDisabledField = function (name) {
            this.elements.fieldsEl.forEach((el) => {
              const fieldName = el.getAttribute('name');

              if (fieldName === name) {
                  el.disabled = true;
                }
              });
            return this;
          };
          CalculatorVacation.prototype.setEnabledField = function (name) {
            this.elements.fieldsEl.forEach((el) => {
              const fieldName = el.getAttribute('name');
              if (fieldName === name) {
                  el.disabled = false;
                }
              });
            return this;
          };
          CalculatorVacation.prototype.collectData = function () {
            var self = this;
            if (this.elements.fieldsEl) {
              this.elements.fieldsEl.forEach((el) => {
                const name = el.name;
                let val = el.value;
                const type = el.classList.contains('datapicker') ? 'date' : el.getAttribute('type');
                if (type === 'checkbox') {
                  val = el.checked;
                }

                if (type !== 'radio' || (type === 'radio' && el.checked)) {
                  self.setFieldData(type, name, val);
                }

              });
            }
            return this;
          };

          CalculatorVacation.prototype.preCalculate = function () {
            const noIncome = this.getFieldData('no_income');
            let period = this.getFieldData('period');
            const rate = this.getFieldData('rate');
            const isLeapYear = this.getFieldData('is_leap_year');
            let startWork = this.getFieldData('date_work_start');
            const startMonthVacation = this.getFieldData('_date_vacation_start_mont');
            const notWorkingDays = this.getFieldData('not_working_days') || 0;
            const notWorkingDaysWar = this.getFieldData('not_working_days_war') || 0;
            let totalIncome = this.getFieldData('total_income') || 0;
            const minSalary = this.getFieldData('min_salary') || 0;
            const vacationDays = this.getFieldData('vacation_days') || 0;
            const holidaysOptions = this.getFieldData('holidays') || [];

            let difDays = startMonthVacation.diff(startWork, 'days');
            let difMonth = startMonthVacation.diff(startWork, 'months');

            this.setFieldData('number', 'min_salary', w._minZP);
            this.setFieldData('array', 'holidays', w._holidaysArray);

            if (this.options.debug) {
              console.log('Start work:', startWork.format('DD.MM.YYYY'));
              console.log('startMonthVacation:', startMonthVacation.format('DD.MM.YYYY'));
              console.log('difDays:', difDays);
              console.log('period:', period);
            }

            if (difMonth > 12) {
              startWork = startMonthVacation.clone().subtract(1, 'years').startOf('month');
              difDays = startMonthVacation.diff(startWork, 'days');
              if (period !== '0') {
                period = '0';
                this.setFieldData('choices', 'period', '0', true);
              }
            }
            if (difMonth < 12 && difMonth >= 1) {
              if(startWork.date() !== 1) {
                startWork.startOf('month').add(1, 'month');
                difDays = startMonthVacation.diff(startWork, 'days');
              }
              if(period !== '1'){
                period = '1';
                this.setFieldData('choices', 'period', '1', true);
              }
            }
            if (difMonth < 1 && period !== '2') {
              period = '2';
              this.setFieldData('choices', 'period', '2', true);
            }

            if (period === '2' || noIncome) {
              startWork = startMonthVacation.clone().subtract(1, 'years');
              difDays = startMonthVacation.diff(startWork, 'days');
              totalIncome = (minSalary > rate) ? minSalary * 12 : rate * 12;
              this.setFieldData('number', 'total_income', totalIncome, true);
            }

            let worksDays = difDays;
            let weekends = 0;
            let holidays = 0;

            for (let i = 0; i < difDays; i++) {
              // if (this.options.debug) console.log(startWork.format('DD.MM.YYYY'));
              if (
                  holidaysOptions.includes(startWork.format('DD.MM')) ||
                  holidaysOptions.includes(startWork.format('DD.MM.YYYY'))
              ) {
                holidays++;
                // if (this.options.debug) console.log(startWork.format('DD.MM.YYYY'), 'date in period is holiday');
              }
              startWork.add(1, 'days');
            }

            if (this.options.debug) {
              console.log('difMonth:', difMonth);
              console.log('difDays:', difDays);
              console.log('holidays:', holidays);
              console.log('weekends:', weekends);
            }

            worksDays -= notWorkingDays;
            worksDays -= notWorkingDaysWar;
            worksDays -= holidays;
            if (period !== '2' && !noIncome) {
              worksDays -= weekends;
            }

            this.setFieldData('number', 'days_for_mid_rate', worksDays, true);

            const middleRate = (totalIncome / worksDays).toFixed(2);
            this.setFieldData('number', 'middle_rate', middleRate, true);
            this.setFieldData('number', 'vacation_sum', middleRate * vacationDays, true);

            return this;
          };

          CalculatorVacation.prototype.calculate = function () {

            return this;
          };

          CalculatorVacation.prototype.validateFields = function () {
            let valid = true;
            const fields = this.elements.mainEl.querySelectorAll(this.options.elements.fields);

            if (fields) {
              fields.forEach((field) => {
                if (!this.validateField(field)) {
                  valid = false;
                }
              });
            }

            return valid;
          };

          CalculatorVacation.prototype.validateField = function (field) {
            let valid = true;
            const name = field.name;
            const type = field.type;
            const val = field.value;
            const fieldContainer = field.closest('.field');
            const isDate = field.classList.contains('datapicker');
            const isDisabled = field.disabled;

            if (!isDisabled) {
              if (val) {
                switch (type) {
                  case 'radio':

                    break;
                  case 'text':
                    if (isDate) {
                      if (!this.options.regexp.date2.test(val)) {
                        valid = false;
                      }
                    }
                    break;
                  case 'number':

                    switch (name) {
                      case 'total_income':
                        if (val === '0' && (!this.getFieldData('no_income') && this.getFieldData('period') !== '2')) {
                          valid = false;
                        }
                        break;
                      case 'rate':
                        if (val === '0' && (this.getFieldData('no_income') || this.getFieldData('period') === '2')) {
                          valid = false;
                        }
                        break;
                      default:
                        break;
                    }

                    break;
                  default:
                    break;
                }
              } else {
                switch (name) {
                  case 'not_working_days':
                    break;
                  case 'not_working_days_war':
                    break;
                  case 'total_income':
                    if (!this.getFieldData('no_income') && this.getFieldData('period') !== '2') {
                      valid = false;
                    }
                    break;
                  case 'rate':
                    if (this.getFieldData('no_income') || this.getFieldData('period') === '2') {
                      valid = false;
                    }
                    break;
                  default:
                    valid = false;
                    break;
                }

              }
            }
            if (fieldContainer) {
              fieldContainer.classList.toggle('invalid', !valid);
              field.classList.toggle('invalid', !valid);
            }

            return valid;
          };

          CalculatorVacation.prototype.createEvents = function () {
            const self = this;

            if (this.elements.fieldsEl) {
              this.elements.fieldsEl.forEach(function(element) {
                element.addEventListener('change', handleFieldChange);
                element.addEventListener('blur', handleFieldChange);
              });
            }
            function handleFieldChange(event) {
              const el = event.target;
              const type = el.classList.contains('datapicker') ? 'date' : el.getAttribute('type');
              let val = el.value;
              const name = el.getAttribute('name');

              if (type === 'checkbox') {
                val = el.checked;
              }

              if (name === 'date_vacation_start') {
                refreshSalary(val);
                refreshHolidays(self.getFieldData('date_work_start').format('DD.MM.YYYY'));
              }
              if (name === 'date_work_start') {
                refreshHolidays(val);
              }

              if (this.validateField(el)) {
                if (val !== self.getFieldData(name)) {
                  this
                      .setFieldData(type, name, val)
                      .preCalculate();
                }
              }
            }


            if (this.elements.calculateEl) {
              this.elements.calculateEl.addEventListener('click', function () {
                console.log('calculate');
                if (self.validateFields()) {
                  self.collectData()
                      .preCalculate();
                }
              });
            }
            return this;
          };

          return CalculatorVacation;
      }

      w.uteka = w.uteka || {};
      w.uteka.CalculatorVacation = createCalculatorVacation();
    }
)(window);

document.addEventListener('DOMContentLoaded', function () {
  const vacationCalc = document.getElementById('calculator-vacation');
  if (vacationCalc) {
    if (window.uteka.CalculatorVacation) {
      window.calculatorVacation = new window.uteka.CalculatorVacation({debug: false});
    }
  }
});
